import { FC } from 'react';

import {
    AutoPriceProgress,
    BulkAutoPriceControls,
} from './BulkAutoPriceSettings';
import { Button } from '../../../../components/ui/Button';

interface Props {
    progress: AutoPriceProgress;
    onRetryFailed: BulkAutoPriceControls['onRetryFailed'];
}

export const BulkAutoPriceProgress: FC<Props> = ({
    progress,
    onRetryFailed,
}) => {
    return (
        <div
            className="ml-auto flex items-center gap-2 text-xs text-muted-foreground"
            data-testid="auto-price-progress"
        >
            <span role="status" aria-live="polite">
                Автоціни: {progress.completed} із {progress.total}
                {progress.errors > 0 && ` · помилок: ${progress.errors}`}
            </span>
            {progress.errors > 0 && (
                <Button
                    type="button"
                    variant="link"
                    className="h-auto p-0 text-xs"
                    onClick={onRetryFailed}
                >
                    Повторити
                </Button>
            )}
        </div>
    );
};
